export enum TypeOfOption {
  CALL = "Call Option",
  PUT_AND_CALL = "Put and Call Option",
}
